import SvgDrawPlugin from 'tween-one/es/plugins/SvgDrawPlugin';
export default SvgDrawPlugin;